import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, NgForm } from '@angular/forms';
import { AnalyticEvents } from '@app/enums';
import { Question } from '@app/models/recruiting/question.model';
import { AnalyticService } from '@app/services';
import { AccessLevelDisplayOptions } from '@app/types/translatables/access-level-display.options';
import { JobPosting } from '@models/recruiting/job-posting.model';
import { HiringAccessLevelLabel, HiringAccessLevels } from '../../constants/hiring-access-levels.constant';

@Component({
    selector: 'app-add-auto-archiving-questions-dialog',
    templateUrl: './add-auto-archiving-questions-dialog.component.html',
    styleUrls: ['./add-auto-archiving-questions-dialog.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AddAutoArchivingQuestionsDialogComponent),
            multi: true,
        },
    ],
})
export class AddAutoArchivingQuestionsDialogComponent implements OnInit {
    @Input() open = false;
    @Input() question: Question;
    @Input() mode: 'edit' | 'add';
    @Input() jobPosting: JobPosting;

    @Output() questionAdded = new EventEmitter<Question>();
    @Output() questionEdited = new EventEmitter<Question>();
    @Output() closing = new EventEmitter<boolean>();

    accessLevels: HiringAccessLevelLabel[];
    accessLevelDisplay = AccessLevelDisplayOptions;
    headerText: string;

    constructor(private analyticsService: AnalyticService) {}

    ngOnInit(): void {
        this.accessLevels = Object.values(HiringAccessLevels).map((x) => x.label);
        this.headerText = `applicant-tracker.components.auto-archiving-questions.${this.mode === 'add' ? 'addAutoArchivingQuestion' : 'editAutoArchivingQuestion'}`;
        this.question = this.question ? this.question : new Question({ isAutoArchive: true, isRequired: true });
    }

    onAdd(form: NgForm): void {
        if (form.invalid) {
            return;
        }

        this.questionAdded.emit(this.question);
        this.analyticsService.trackEvent(this.getEvent());
        this.closing.emit(true);
    }

    onEdit(form: NgForm): void {
        if (form.invalid) {
            return;
        }

        this.questionEdited.emit(this.question);
        this.analyticsService.trackEvent(this.getEvent());
        this.closing.emit(true);
    }

    onClose(): void {
        this.closing.emit(true);
    }

    private getEvent(): AnalyticEvents {
        if (this.mode === 'add') {
            return this.jobPosting?.isPersisted
                ? AnalyticEvents.AddAutoArchiveQuestionFromScratchOnExistingPosting
                : AnalyticEvents.AddAutoArchiveQuestionFromScratchOnNewJobPosting;
        }

        return this.jobPosting?.isPersisted
            ? AnalyticEvents.EditAutoArchiveQuestionOnExistingPosting
            : AnalyticEvents.EditAutoArchiveQuestionOnNewJobPosting;
    }
}
